module.exports = __webpack_public_path__ + "static/media/account.6ba75dc0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Navigation/assets/account.svg
// module id = 85
// module chunks = 0